export default __webpack_public_path__ + "static/media/pinterest-black.549c9ba5.svg";